// extracted by mini-css-extract-plugin
export default {"wrapper":"VideoWrapper_wrapper__gtIt0","videoContainer":"VideoWrapper_videoContainer__ucLCk","light":"VideoWrapper_light__vv3z9"};